export default {
      id: "soundcloud-usage",
      viewBox: "0 0 640 512",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#soundcloud",
      toString: function () {
        return this.url;
      }
    }